<template>
  <div class="mb-3" v-if="pendings_transfert_request.length > 0">
    <div>
      Vous avez déjà envoyé
      <span v-if="pendings_transfert_request.length == 1">une invitation de transfert d'inscription:</span>
      <span v-else>des invitations de transfert d'inscription:</span>
    </div>
    <v-alert color="dark-green" variant="tonal" class="mt-1" v-for="pending in pendings_transfert_request"
      :key="pending.id">Invitation envoyée à <b>{{ pending.recipient }}</b> pour un transfert d'inscription
      <v-btn v-if="mainStore.authAdmin.hasSuperAdminRights" size="sm" class="pa-2" @click="copyLink(pending)"
        text>Copier le lien</v-btn>

    </v-alert>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
import AdminService from "@/services/admin.service.js";
export default {
  props: ["id_inscription", "admin"],
  data() {
    return {
      pendings_transfert_request: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async copyLink(pending) {
      let link = 'https://sportips.fr/inscription/' + this.mainStore.module.base + '/transfert/?req=' + pending.token;
      await navigator.clipboard.writeText(link);
    },
  },
  async mounted() {
    if (this.admin) {
      let request = await AdminService.getTransfertInscriptionRequests(this.id_inscription);
      this.pendings_transfert_request = request;
    } else {
      let request = await UserService.getTransfertInscriptionRequests(this.id_inscription);
      this.pendings_transfert_request = request;
    }
  },
};
</script>

<style lang="scss" scoped></style>